import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "../../lib/api";
import { fmtDate } from "../../lib/model";

export function HistoryDialog({ open, onOpenChange, inspectionId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (open) api.get(`/inspections/${inspectionId}/history`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [open, inspectionId]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl bg-[#0B1520] border-[#1E2F45] max-h-[85vh] overflow-y-auto" data-testid="history-dialog">
        <DialogHeader>
          <DialogTitle className="font-display uppercase tracking-wider text-2xl">Histórico de alterações</DialogTitle>
          <DialogDescription>Todas as alterações salvas são registradas com usuário, data e valores anterior/novo.</DialogDescription>
        </DialogHeader>
        {!items && <div className="text-slate-400 text-sm">Carregando...</div>}
        {items && !items.length && <div className="text-slate-400 text-sm" data-testid="history-empty">Nenhuma alteração registrada ainda.</div>}
        <div className="flex flex-col gap-4">
          {(items || []).map((h) => (
            <div key={h.id} className="border border-[#1E2F45] rounded-sm" data-testid="history-entry">
              <div className="px-3 py-2 bg-[#050B10] flex justify-between font-mono text-xs">
                <span className="text-[#FFD500]">{h.user_name}</span>
                <span className="text-slate-400">{fmtDate(h.at)} · {h.total} alteração(ões)</span>
              </div>
              <table className="w-full text-xs font-mono">
                <tbody>
                  {h.changes.slice(0, 40).map((c, i) => (
                    <tr key={i} className="border-t border-[#1E2F45]/60">
                      <td className="px-3 py-1.5 text-slate-300 break-all w-1/2">{c.campo}</td>
                      <td className="px-3 py-1.5 text-slate-500 line-through break-all">{c.de}</td>
                      <td className="px-3 py-1.5 text-white break-all">{c.para}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {h.changes.length > 40 && <div className="px-3 py-1.5 text-[11px] text-slate-500">+ {h.changes.length - 40} alterações</div>}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
